import { FC } from "react";

import dynamic from "next/dynamic";

import { getTestimonialsQuery } from "lib/sanity/queries";
import { getClient } from "lib/sanity/server";

import BiggestNamesInSolar from "components/biggest-names-in-solar";
import DemoFormSection, { DemoSchemes } from "components/demo-form-section";

import Page from "../components/layout/page";
import { Testimonial } from "../components/views/demo/testimonials";

const Testimonials = dynamic(() => import("../components/views/demo/testimonials"));

type SeeADemoProps = { testimonials: Testimonial[] };
const SeeADemo: FC<SeeADemoProps> = ({ testimonials }: SeeADemoProps) => (
  <Page
    title="Enerflo Solar Software Platform | Discover Enerflo!"
    description="We CAN’T WAIT to show you how Enerflo works, how it’s different from other Solar Platforms and how it can literally transform your solar sales and operations."
  >
    <DemoFormSection scheme={DemoSchemes.NAVY} />
    <Testimonials testimonials={testimonials} />
    <BiggestNamesInSolar />
  </Page>
);

export default SeeADemo;

export async function getStaticProps(ctx) {
  const { preview = null } = ctx;

  const client = getClient(preview);
  let testimonials: Testimonial[] = [];

  try {
    testimonials = await client.fetch(getTestimonialsQuery(preview));
  } catch (e) {
    console.error("Unable to fetch testimonials", e);
  }

  return {
    props: {
      preview,
      testimonials,
    },
  };
}
